module.exports = __webpack_public_path__ + "static/media/RiotGames-Logo.a5079a02.png";